import { useQuery } from '@tanstack/react-query';
import { listarEstados, listarMunicipios } from '../api';

/**
 * UFs e municípios são dados de referência estáticos — cacheamos por
 * tempo infinito na sessão (não vale a pena refetch em background).
 * Backend já faz IBGE-first com fallback local, então uma única
 * requisição por hook é suficiente.
 */
export const GEO_KEYS = {
  estados: ['geo', 'estados'] as const,
  municipios: (uf: string) => ['geo', 'municipios', uf] as const,
};

export function useEstados() {
  return useQuery({
    queryKey: GEO_KEYS.estados,
    queryFn: listarEstados,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}

export function useMunicipios(uf: string | null | undefined) {
  return useQuery({
    queryKey: GEO_KEYS.municipios(uf ?? ''),
    queryFn: () => listarMunicipios(uf as string),
    enabled: !!uf,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
